import axios, { type AxiosInstance } from 'axios';

export class SpreadsheetReportTemplateRequester {
  private requester: AxiosInstance;

  constructor() {
    this.requester = axios.create({
      baseURL: 'https://new-routing-report-templates.s3.amazonaws.com/',
    });
  }

  public getRoutesReportTemplate = async (): Promise<Blob> => {
    return this.requester
      .request({
        url: 'routes_report_v4.xlsx',
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => response.data);
  };

  public getActivitiesTemplate = async (): Promise<Blob> => {
    return this.requester
      .request({
        url: 'activities_report_v5.xlsx',
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => response.data);
  };

  public getRouteExportTemplate = async (): Promise<Blob> => {
    return this.requester
      .request({
        url: 'route_export.xlsx',
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => response.data);
  };
}

export default SpreadsheetReportTemplateRequester;
